module.exports = __webpack_public_path__ + "public/img/logo_side.5bd3d562.png";